import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet, BackHandler, Platform, StatusBar, TouchableOpacity, ScrollView, Linking } from 'react-native';

import Colors from '../constants/Colors';
import { Ionicons, } from "@expo/vector-icons"
import { NativeBaseProvider, useMediaQuery, } from 'native-base';
import { useDispatch, useSelector } from 'react-redux';
import { getDetailsService } from '../store/action/finalproduct';
import { logOut } from '../store/action/userLogin';
import AsyncStorage from '@react-native-async-storage/async-storage';










const DetailsService = (props) => {

    //const tokens = "2|WHyjzuT213icASOZyDMHFmRUaYcJfLA5S9Y9kjhh"
    const tokens = useSelector((store) => store.userLogin.datatoken);
    const dispatch = useDispatch();
    const [Ostan, setOstan] = useState("");
    const [City, setCity] = useState("");
    const [Active, setActive] = useState(4);
    const [DetailsSingle, setDetailsSingle] = useState("");


    const logOutHandler = async () => {
        try {
            //   console.log("logout");
            await dispatch(logOut());
            await AsyncStorage.removeItem("access_token");
            props.navigation.navigate("splash");
        } catch (err) {
            console.log(err);
        }
    };


    const getDetailsSERVICEHandler = async () => {
        try {

            //setState({ ...State, isLoading: true })
            const res = await dispatch(getDetailsService(tokens,
                props.route.params.ids
            ));
            setDetailsSingle(res.data.data.single_services)

            //console.log(res.data.data.single_services);
            setOstan(res.data.data.single_services.state)
            setCity(res.data.data.single_services.city)
            // setState({ ...State, isLoading: false })

        } catch (err) {
            // logOutHandler();
        }
    };







    useEffect(() => {

        getDetailsSERVICEHandler()

        if (!tokens) {
            logOutHandler()
        }
    }, [])










    const separate = (num) => {
        let number = num.replace(/\D/g, "");
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const handleOpencall = () => {
        Linking.openURL(`tel:${DetailsSingle.mobile}`);
    };


    function handleBackButtonClick() {

        props.navigation.goBack();
        return true;

    }

    useEffect(() => {
        BackHandler.addEventListener("hardwareBackPress", handleBackButtonClick);
        return () => {
            BackHandler.removeEventListener("hardwareBackPress", handleBackButtonClick);
        };
    }, []);

    const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth: 500
    });

    return (

        <NativeBaseProvider>


            <View style={{
                width: isSmallScreen ? "100%" : 500,
                height: "100%",
                marginLeft:isSmallScreen?0:"35%",
                backgroundColor: Colors.background,
                position: Platform.OS == "web" ? "fixed" : "relative"
            }}>


                <View style={styles.viewHeader}>
                    <StatusBar backgroundColor={Colors.primary} />
                    <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.menu}   >
                        <Ionicons name="arrow-forward-outline" size={25} color={Colors.background} />
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.textheader}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                            جزئیات خدماتی
                        </Text>
                    </TouchableOpacity>



                </View>




                <View style={{ justifyContent: "center", alignItems: "center", width: "90%", height: 50, marginBottom: 10, backgroundColor: Colors.secondText2, left: 20, marginTop: 10, borderRadius: 20, borderWidth: 1, borderColor: Colors.secondText3 }}>
                    <Text style={{ fontFamily: "MontserratBold", fontSize: 20, color: Colors.black, }}>{DetailsSingle.first_name} {DetailsSingle.last_name}</Text>

                </View>

                <View style={{ flexDirection: "row", width: "90%", height: 50, marginBottom: 10, backgroundColor: Colors.secondText2, left: 20, marginTop: 10, borderRadius: 20, borderWidth: 1, borderColor: Colors.secondText3, alignItems: "center", justifyContent: "space-between", paddingRight: "3%", paddingLeft: "3%" }}>





                    <TouchableOpacity onPress={() => {
                        setActive(1)
                    }} style={{ justifyContent: "center", }}>
                        <Text style={{ fontFamily: Active == 1 ? "MontserratBold" : "Montserrat", fontSize: 14, color: Active == 1 ? Colors.primary : Colors.black }}>ارتباط با ما</Text>
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => {
                        setActive(2)
                    }} style={{ justifyContent: "center", }} >
                        <Text style={{ fontFamily: Active == 2 ? "MontserratBold" : "Montserrat", fontSize: 14, color: Active == 2 ? Colors.primary : Colors.black }}>قیمت</Text>
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => {
                        setActive(3)
                    }} style={{ justifyContent: "center", }}>
                        <Text style={{ fontFamily: Active == 3 ? "MontserratBold" : "Montserrat", fontSize: 14, color: Active == 3 ? Colors.primary : Colors.black }}>ماشین الات</Text>
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => {
                        setActive(4)
                    }} style={{ justifyContent: "center", }}>
                        <Text style={{ fontFamily: Active == 4 ? "MontserratBold" : "Montserrat", fontSize: 14, color: Active == 4 ? Colors.primary : Colors.black, }}>اطلاعات کلی</Text>
                    </TouchableOpacity>
                </View>




                {Active == 4
                    ?

                    <View style={styles.view}>
                        <View style={{ backgroundColor: Colors.secondText2, borderRadius: 20, width: "40%", height: 40, marginTop: 10, marginBottom: 8, justifyContent: 'center', alignItems: "center", left: "27%" }}>
                            <Text style={styles.texttitle}>{Ostan.state}, {City.city}</Text>

                        </View>

                        <View style={styles.viewline} >
                            <Text style={styles.textlineR}>{DetailsSingle.address}</Text>
                        </View>

                        <View style={styles.viewline} >

                            <Text style={{ fontFamily: "Montserrat", fontSize: 16, color: Colors.black, position: "absolute", right: "5%" }}>{DetailsSingle.first_name}{DetailsSingle.last_name}</Text>
                        </View>


                        <View style={{ width: "90%", height: 300, marginTop: 10, }} >

                            <Text numberOfLines={7} style={{ textAlign: "right", fontFamily: "Montserrat", fontSize: 16, color: Colors.black }}>{DetailsSingle.description}</Text>
                        </View>

                    </View>
                    :
                    <View></View>
                }





                {Active == 3
                    ?


                    <View style={{
                        display: "flex", flexWrap: "wrap", flexDirection: 'row',
                        justifyContent: "center",
                        width: "90%", alignSelf: "auto",
                        backgroundColor: Colors.background1,
                        marginTop: 10,
                        left: "3%",
                        borderWidth: 1,
                        borderColor: Colors.secondText,
                        borderRadius: 10,
                        elevation: 2,
                        marginBottom: 10
                    }}>
                        {DetailsSingle.machinery.map((item, i) => {
                            return (

                                <View key={i} style={{ borderWidth: 2, borderColor: Colors.secondText3, marginLeft: 10, marginRight: 10, backgroundColor: Colors.secondText2, borderRadius: 20, width: "40%", height: 60, marginTop: 20, marginBottom: 20, justifyContent: 'center', alignItems: "center", }}>
                                    <Text style={{ fontFamily: "MontserratBold", fontSize: 13, color: Colors.black, }}>{item.name}</Text>
                                </View>)
                        })}

                    </View>


                    :
                    <View></View>
                }












                {Active == 2
                    ?
                    <ScrollView>
                        <View style={{
                            flexDirection: "column",
                            alignItems: "center",
                            width: "90%",
                            alignSelf: "auto",
                            backgroundColor: Colors.background1,
                            marginTop: 10,

                            left: "5%",
                            borderWidth: 1,
                            borderColor: Colors.secondText,
                            borderRadius: 10,
                            elevation: 2,

                        }}>






                            <View style={{ flexDirection: 'row', width: "100%", height: 40, borderTopRightRadius: 10, borderTopLeftRadius: 10 }}>
                                <View style={{ width: "30%", height: 40, borderTopLeftRadius: 10, borderBottomWidth: 1, borderRightWidth: 1, alignItems: "center", justifyContent: "center" }}>

                                    <Text style={{ fontFamily: "MontserratBold", fontSize: 12, color: Colors.black, }}>قیمت واحد(ریال)</Text>
                                </View>

                                <View style={{ width: "60%", height: 40, alignItems: "center", borderBottomWidth: 1, justifyContent: "center" }}>
                                    <Text style={{ fontFamily: "MontserratBold", fontSize: 12, color: Colors.black, }}>شرح خدمات</Text>
                                </View>

                                <View style={{ width: "10%", height: 40, borderTopRightRadius: 10, borderBottomWidth: 1, borderLeftWidth: 1, alignItems: "center", justifyContent: "center" }}>
                                    <Text style={{ fontFamily: "MontserratBold", fontSize: 12, color: Colors.black, }}>ردیف</Text>
                                </View>
                            </View>


                            {DetailsSingle.prices.map((item, i) => {
                                return (
                                    <View key={i} style={{ flexDirection: 'row', width: "100%", height: 40, borderTopRightRadius: 10, borderTopLeftRadius: 10 }}>
                                        <View style={{ width: "30%", height: 40, borderTopLeftRadius: 10, borderRightWidth: 1, borderBottomWidth: 1, alignItems: "center", justifyContent: "center" }}>

                                            <Text style={{ fontFamily: "MontserratBold", fontSize: 12, color: Colors.black, }}>{separate(JSON.stringify(item.price))}</Text>
                                        </View>

                                        <View style={{ width: "60%", height: 40, borderBottomWidth: 1, alignItems: "center", justifyContent: "center" }}>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.black, }}>{item.service}</Text>
                                        </View>

                                        <View style={{ width: "10%", height: 40, borderTopRightRadius: 10, borderLeftWidth: 1, borderBottomWidth: 1, alignItems: "center", justifyContent: "center", }}>
                                            <Text style={{ fontFamily: "MontserratBold", fontSize: 12, color: Colors.black, }}>{i + 1}</Text>
                                        </View>
                                    </View>
                                )
                            })}




                        </View>

                    </ScrollView>
                    :
                    <View></View>
                }

                {Active == 1
                    ?
                    <View style={styles.view}>
                        <View style={{ backgroundColor: Colors.secondText2, borderRadius: 20, width: "40%", height: 40, marginTop: 10, marginBottom: 8, justifyContent: 'center', alignItems: "center", left: "27%" }}>
                            <Text style={styles.texttitle}>{Ostan.state}, {City.city}</Text>

                        </View>

                        <View style={styles.viewline} >
                            <Text style={styles.textlineR}>{DetailsSingle.address}</Text>
                        </View>

                        <TouchableOpacity onPress={handleOpencall} style={{ flexDirection: "row", borderWidth: 2, borderColor: Colors.secondText3, marginLeft: 10, marginRight: 10, borderRadius: 20, width: "50%", height: 60, marginTop: 20, marginBottom: 8, justifyContent: 'center', alignItems: "center" }}>
                            <View style={{ elevation: 5, width: 40, height: 40, borderRadius: 20, backgroundColor: Colors.success, alignItems: "center", justifyContent: "center", marginRight: 10 }}>
                                <Ionicons name="call" size={25} color={Colors.background} />
                            </View>


                            <Text style={{ fontFamily: "MontserratBold", fontSize: 13, color: Colors.black, }}>تماس با خدماتی</Text>
                        </TouchableOpacity>




                    </View>
                    :
                    <View></View>
                }


            </View>
        </NativeBaseProvider>

    );
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        position: Platform.OS == "web" ? "fixed" : "relative"
    },
    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height: Platform.OS == "web" ? 60 : 80,
        backgroundColor: Colors.primary,
    },

    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: Platform.OS == "web" ? "15%" : "35%",

    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 110,
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "12%",
        top: Platform.OS == "web" ? "15%" : "33%"
    },
    textinput: {
        paddingLeft: Platform.OS === "web" ? "40%" : 0,
        flexDirection: "row",
        width: "90%",
        height: 60,
        backgroundColor: Colors.background2,
        position: "absolute",
        left: "5%",
        borderRadius: 10,
        borderWidth: 1,
        borderColor: Colors.secondText3,
        padding: 10,
        paddingRight: 50,
        fontFamily: "Montserrat",
        marginTop: 15,


    },


    view: {
        flexDirection: "column",
        alignItems: "center",
        width: "90%",
        height: 300,
        backgroundColor: Colors.background1,
        marginTop: 10,
        left: "5%",
        borderWidth: 2,
        borderColor: Colors.secondText,
        borderRadius: 10,

        marginBottom: 10

    },


    texttitle: {
        fontFamily: "Montserrat",
        fontSize: 13,
        color: Colors.black,


    },

    viewline: {
        width: "100%",
        height: 30,
        justifyContent: "center",
        flexDirection: "row",
        marginTop: 5

    },

    textlineR: {
        fontFamily: "Montserrat",
        fontSize: 13,
        color: Colors.black,
        position: "absolute",
        right: "5%"

    },

})




export default DetailsService